// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".terms-index[data-v-273f6389] {\n  background: #FFFFFF;\n}\n.terms-index .terms-version[data-v-273f6389] {\n  position: relative;\n  top: 65px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
